import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import EditableContainer from '@v4/components/common/EditableContainer'
import EditableHTML from '@v4/components/common/EditableHTML'
import { Box } from '@material-ui/core'
import Slider from '@v4/components/common/Slider'
import VideoBlock from '@v4/components/sections/Video/components/VideoBlock'
import PageMetaData from '@v4/utils/data/PageMetaData'
import IconButton from '@material-ui/core/IconButton'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import Item from './components/Item'
import { useVideo6 } from './Video6.hooks'

const Video6 = props => {
	const [
		{
			classes,
			activeItemKey,
			sliderRef,
			sliderConfig,
			items,
			video,
			showLeftButton,
			showRightButton,
			mobileAlignment,

			title,
			titleKey,
			titleConfig,
			titleEditable,
		},
		{ handleNextClick, handlePrevClick, handleTitleClick, handleTitleChange },
	] = useVideo6(props)

	return (
		<>
			<EditableContainer
				visible={!!title}
				fieldConfig={titleConfig}
				onAdd={handleTitleChange}
				editable={titleEditable}
				wrapper={({ children }) => (
					<Box width="100%" mb={4.5}>
						{children}
					</Box>
				)}
			>
				<EditableHTML
					key={titleKey}
					className={clsx(classes.title, 'video6-title-block')}
					html={title}
					onClick={handleTitleClick}
					editable={titleEditable}
					onChange={handleTitleChange}
				/>
			</EditableContainer>

			{video?.metaValue && (
				<div key={`${video.tierKey}_${video.index}`} className={clsx(classes.container, 'video6-video-wrap')}>
					<VideoBlock className="video6-video-block" value={video.metaValue} />
				</div>
			)}

			{!_.isEmpty(items) && (
				<div className={clsx(classes.sliderContainer, 'video6-slider-container')}>
					<Slider ref={sliderRef} {...sliderConfig}>
						{_.map(items, (key, index) => (
							<Item
								key={key}
								itemKey={key}
								active={key === activeItemKey}
								group="items"
								index={index}
								mobileAlignment={mobileAlignment}
							/>
						))}
					</Slider>
					{(showLeftButton || showRightButton) && (
						<div className={classes.control}>
							{showLeftButton && (
								<IconButton
									onClick={handlePrevClick}
									className={clsx(classes.button, classes.leftButton, 'video6-slider-left-button')}
								>
									<ChevronLeftIcon className={classes.icon} />
								</IconButton>
							)}
							{showRightButton && (
								<IconButton
									onClick={handleNextClick}
									className={clsx(classes.button, classes.rightButton, 'video6-slider-right-button')}
								>
									<ChevronRightIcon className={classes.icon} />
								</IconButton>
							)}
						</div>
					)}
				</div>
			)}
		</>
	)
}

Video6.propTypes = {
	metaData: PropTypes.shape({
		title: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		backgroundDefault: PropTypes.instanceOf(PageMetaData),
		marginTop: PropTypes.instanceOf(PageMetaData),
		marginBottom: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Video6)
